import CartazCanvas from "./CartazCanvas";
import { CARTAZ_GRANDE, CARTAZ_MEDIO } from "../../EncarteConstants";
import { useContext } from "react";
import { calcProductStylesOcurrence } from "../CanvasGeneralStyles";
import WorkspaceContext from "../../../WorkspaceContext";
import { useOutletContext } from "react-router";
import PremiumContentProtectiveLayer from "../../../../sharable/PremiumContentProtectiveLayer";
import { CanvasContainer, Grid } from "./CartazCanvasGrid.styles";

//Function to calculate the grid for the prateleira:
// - Small and Medium: 2 columns, rows according to quantity
// - Large: 1 column, 1 row
const getCanvasGrid = (productsSize, format) => {
  if (format === CARTAZ_GRANDE) {
    return { columns: 1, rows: 1 };
  } else if (format === CARTAZ_MEDIO) {
    return { columns: 2, rows: 2 };
  }

  return { columns: 2, rows: 4 };
};

export default function CartazCanvasGrid({ products, canvasScale, model }) {
  const { styles } = useContext(WorkspaceContext);
  const { isAccountPremium } = useOutletContext();
  const grid = getCanvasGrid(products?.length, styles.format);
  const headerAndFooterStyles = calcProductStylesOcurrence(products);

  return (
    <CanvasContainer canvasScale={canvasScale}>
      {!isAccountPremium && (
        <PremiumContentProtectiveLayer className="format-premium" />
      )}
      <Grid
        columns={grid.columns}
        rows={grid.rows}
        canvasScale={canvasScale}
        styles={styles}
        className="cartaz-grid"
      >
        {products.map((product, i) => (
          <CartazCanvas
            key={product.id || i}
            product={product}
            canvasScale={canvasScale}
            model={model}
            styles={styles}
            headerAndFooterStyles={headerAndFooterStyles}
            index={i}
          />
        ))}
      </Grid>
    </CanvasContainer>
  );
}
